import {
  Col,
  Descriptions,
  Divider,
  Modal,
  Row,
  Spin,
  Statistic,
  Tag,
  Typography,
} from 'antd'
import dayjs from 'dayjs'
import RunResults from './RunResults'
import {
  formatPassRate,
  isRunActive,
  runStatusColor,
} from './runsAdminModel'
import { useRunQuery } from './runsAdminQueries'

type Props = {
  runId: string | null
  onClose: () => void
}

const RunDetailModal = ({ runId, onClose }: Props) => {
  const { data: run, isLoading } = useRunQuery(runId)
  const active = run ? isRunActive(run.status) : false

  return (
    <Modal
      open={runId != null}
      onCancel={onClose}
      footer={null}
      title="Run detail"
      width={760}
      destroyOnClose
    >
      {isLoading || !run ? (
        <div style={{ textAlign: 'center', padding: 48 }}>
          <Spin />
        </div>
      ) : (
        <>
          <Descriptions column={2} size="small" bordered>
            <Descriptions.Item label="Suite" span={2}>
              {run.suite}
            </Descriptions.Item>
            <Descriptions.Item label="Model">{run.model}</Descriptions.Item>
            <Descriptions.Item label="Status">
              <Tag color={runStatusColor(run.status)}>{run.status}</Tag>
              {active && (
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  updating…
                </Typography.Text>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Tag">
              {run.tag ?? <Typography.Text type="secondary">—</Typography.Text>}
            </Descriptions.Item>
            <Descriptions.Item label="Created">
              {dayjs(run.created_at).format('MMM D, YYYY h:mm A')}
            </Descriptions.Item>
          </Descriptions>

          <Row gutter={16} style={{ marginTop: 16 }}>
            <Col span={6}>
              <Statistic
                title="Progress"
                value={run.completed_trials}
                suffix={`/ ${run.planned_trials}`}
              />
            </Col>
            <Col span={6}>
              <Statistic
                title="Passed"
                value={run.passed_trials}
                suffix={`/ ${run.completed_trials}`}
              />
            </Col>
            <Col span={6}>
              <Statistic title="Pass rate" value={formatPassRate(run.pass_rate)} />
            </Col>
            <Col span={6}>
              <Statistic
                title="Tokens (in / out)"
                value={`${run.total_input_tokens} / ${run.total_output_tokens}`}
              />
            </Col>
          </Row>

          <Divider orientation="left" style={{ marginTop: 24 }}>
            Results by case
          </Divider>
          <RunResults cases={run.cases} />
        </>
      )}
    </Modal>
  )
}

export default RunDetailModal
